import { render } from "./ResourcesComponent.vue?vue&type=template&id=5ff80b8d&scoped=true"
import script from "./ResourcesComponent.vue?vue&type=script&lang=js"
export * from "./ResourcesComponent.vue?vue&type=script&lang=js"

import "./ResourcesComponent.vue?vue&type=style&index=0&id=5ff80b8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff80b8d"]])

export default __exports__